import { useAtom } from '@reatom/npm-react'
import BigNumber from 'bignumber.js'
import React from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { PairMigrationStatus } from '@root/entities/pair'
import { PnlUsdFormatted } from '@root/shared/core/format'
import { ProgressLine } from '@root/shared/ui-kit'

import type { PairPerformance } from '../../model'
import type { ProgressLinePlacement } from '@root/shared/ui-kit'

type Props = {
  value: PairPerformance
  placement: ProgressLinePlacement
}

export const DistributeTableCurrencyProgress: React.FC<Props> = React.memo(
  ({ value, placement }) => {
    const { pair, performanceUsd, performancePercent } = value
    const [bondingPercentage] = useAtom(pair.bondingPercentage)
    const [migrationStatus] = useAtom(pair.migrationStatus)

    const isMigrated = PairMigrationStatus.isMigrated(migrationStatus)
    const percentage = isMigrated ? 100 : bondingPercentage
    const progressValue = performancePercent
    const intent = performancePercent >= 0 ? 'success' : 'error'

    return (
      <Root>
        <ProgressLine
          value={progressValue}
          percentage={percentage}
          intent={intent}
          placement={placement}
          startContent={
            <StartContent>
              <PnlUsdFormatted pnl={new BigNumber(performanceUsd)} />
            </StartContent>
          }
          endContent={
            <EndContent>
              <Numeric value={performancePercent} forceSign preset="percents" />
              %
            </EndContent>
          }
        />
      </Root>
    )
  },
)

const Root = styled.div`
  --progress-background: var(--appearanceA-7);

  justify-self: stretch;
  width: 100%;
  padding-inline-end: 8px;
  margin-top: 10px;
`

const StartContent = styled.div`
  color: var(--candleGreen-9);
  text-align: right;

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const EndContent = styled(StartContent)`
  font-weight: 400;
`
